import { useSeoFetch } from '@/hooks/useSeoFetch';
import rolesService, { Role } from '@/services/roles';

export default function useRoles(): { roles: Role[]; roleNames: string[]; isLoading: boolean } {
  const { data: roles = [], isLoading } = useSeoFetch<Role[]>(
    ['roles'],
    () => rolesService.getAll(),
    { retry: false }
  );

  return {
    roles,
    roleNames: roles.map((r) => r.name),
    isLoading,
  };
}
